
import {map, catchError} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { TokenInterceptor } from "app/authorized-http.service";
import { Http, Response } from "@angular/http";
import { Observable } from "rxjs";
import { UtilsService } from "app/services/utils.service";
import { RoleListResource } from "app/resources/role/role-list-resource";
import { UserResource } from "app/resources/user/user-resource";
import { AdminProfileResource } from "app/models/AdminProfileResource";
import { HttpClient } from "@angular/common/http";
import { environment } from "app/baseUrl";

@Injectable()
export class AddUserService {

  constructor(private http: HttpClient, private httpa: TokenInterceptor, private utilsService: UtilsService) { }

  getUserRoles(url): Observable<RoleListResource> {
    return this.http.get<RoleListResource> (environment['url'] + url)
  }

  addUser(url,body): Observable<UserResource> {
    return this.http.post<UserResource>(environment['url'] + url, body)
  }

  /* getAdminProfile(url): Observable<AdminProfileResource> {
    return this.http.get<AdminProfileResource> (environment['url'] +url)
  } */

}
